import { useModel, useRouteData } from "@bcm-dev/bcms-vite";
import { Payment } from "model";

import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function CanceledPaymentPrompt
 * @returns {React.Component}
 * @description The prompt that should show after canceling a payment
 * @example
 * <CanceledPaymentPrompt />
 */
export default function CanceledPaymentPrompt(props) {
    // Get the data passed through the route
    const { route } = useRouteData();
    const { branding }= useModel();
    // Replace the state so it doesn't persist on a page reload
    window.history.replaceState({}, document.title);

    const canceled = route !== null ? route.canceled : false;
    const payment = route !== null ? Payment.init(route.payment) : Payment.init({});
    // If the canceled variable is true, and the passed payment is a correct instance
    const isShown = canceled && payment.id !== undefined;
    // Set the amount, account and date variables
    const amount = payment.amount ? payment.amount.format() : "$X.XX";
    const account = payment.to ? `${ payment.to.name } ${ payment.to.number }` : "[ACCOUNT]";
    const date = payment.date ? payment.date.format("M d, Y") : "[DATE]";
    const className = props.className ?? "";
    const hasRealTimeGoodFunds = Payment.hasRealTimeGoodFunds(payment.to?payment.to.paymentType:"", branding);
    return (
        <>
            { isShown &&
                <WidgetView className={`empty canceled-payment-prompt ${className}`}>
                    <WidgetMainContentView className="flex-container">
                        <SVGAsset className="icon set-width" id="CheckmarkIcon" />
                        <span className="flex-width sub-text">Your <b>{ amount }</b> payment to <b>{ account }</b> scheduled for <b>{ date }</b> has been canceled. {hasRealTimeGoodFunds && <>The funds will be refunded to your funding account <b>{ payment.from.number }.</b></>}</span>
                    </WidgetMainContentView>
                </WidgetView> }
        </>
    );
}